import { btn } from "@/ui/btn.js";
import { eventEmitter } from "@/utils/event-emitter.js";
import "@/styles/style.scss";
import "@/styles/components/level-bar.scss";
import { resetGame } from "@/core/resetGame.js";

export function resetBtn(parent) {
  resetGame();
  const elem = btn({
    text: "Reset game",
    parent: parent,
    classes: ["reset", "btn", "controls-bar__item"],
    onClick: () => eventEmitter.emit("reset"),
  });
  return elem;
}
